<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
<div class="layout">
  <div class="layout-container">
    <div class="content">
      <div class="columns">
        <div class="login-container">
          <div class="login-card">
            <div class="lang-toggle">
              <button [class.active]="currentLang === 'en'" (click)="setLanguage('en')">EN</button>
              <span>|</span>
              <button [class.active]="currentLang === 'da'" (click)="setLanguage('da')">DA</button>
            </div>
            <div class="login-box">
              <div class="login-body">
                <img src="assets/images/hit2open Inverted Color (1).png" width="250" alt="">
                <div class="login-content">
                  <h1 style="margin-top: 10px;" id="title" class="title">
                    {{ requires2FA ? ('LOGIN.TWO_FA_TITLE' | translate) : ('LOGIN.TITLE' | translate) }}
                  </h1>

                  <!-- STEP 1: Email + Password -->
                  <form #f="ngForm" aria-labelledby="title" autocomplete="off" *ngIf="!requires2FA">

                    <div class="form-control-group " [ngClass]="{'custom':(!email.invalid && !email.touched)}">
                      <label class="label ps-3" for="input-email">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
                      <input nbInput fullWidth [(ngModel)]="form.email" #email="ngModel" fieldSize="large" name="email"
                        id="input-email" autofocus [required]="true"
                        [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
                        [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
                        [attr.aria-invalid]="email.invalid && email.touched ? true : null" style="width: 94%;">
                      <ng-container *ngIf="email.invalid && email.touched">
                        <p class="caption status-danger" *ngIf="email.errors?.['required']"
                          style="padding-left: 17px !important; margin-bottom: 0px;">
                          {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
                        </p>
                      </ng-container>
                    </div>

                    <div class="form-control-group" [ngClass]="{'custom':(!password.invalid && !password.touched)}">
                      <span class="label-with-link">
                        <label class="label ps-3" for="input-password">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
                      </span>
                      <div class="passwordDiv">
                        <input nbInput fullWidth [(ngModel)]="form.password" #password="ngModel" fieldSize="large"
                          name="password" [type]="show_button ? 'text' : 'password'" id="input-password"
                          [required]="true" [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
                          [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
                          [attr.aria-invalid]="password.invalid && password.touched ? true : null" style="width: 94%;">
                        <i [class]="show_eye ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showPassword()" style="position: absolute;
                                margin-left: -32px;"></i>
                      </div>
                      <ng-container *ngIf="password.invalid && password.touched">
                        <p class="caption status-danger" *ngIf="password.errors?.['required']"
                          style="padding-left: 17px !important; margin-bottom: 0px;">
                          {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
                        </p>
                      </ng-container>
                    </div>

                    <div style="padding: 15px; padding-top: 0px;">
                      <ng-container *ngIf="showErrorMessages">
                        <p class="caption status-danger text-center captionError">
                          {{showErrorMessages}}
                        </p>
                      </ng-container>

                      <button nbButton fullWidth status="primary" size="large" class="crsr"
                        [disabled]="submitted || !f.valid" [class.btn-pulse]="submitted" (click)="onLogin()">
                        {{ 'LOGIN.SUBMIT' | translate }}
                      </button>
                    </div>
                  </form>

                  <!-- STEP 2: TOTP Code Input -->
                  <div *ngIf="requires2FA" style="padding: 15px;">
                    <p style="text-align:center; color:#8f9bb3; font-size:0.875rem; margin-bottom:1.5rem;">
                      {{ 'TWO_FA.DESCRIPTION' | translate }}
                    </p>

                    <div class="form-control-group">
                      <label class="label ps-3">{{ 'TWO_FA.CODE_LABEL' | translate }}</label>
                      <input nbInput fullWidth [(ngModel)]="totpCode" (ngModelChange)="onTotpInput()"
                        fieldSize="large" name="totpCode" type="text" inputmode="numeric"
                        maxlength="6" placeholder="000000"
                        style="width:94%; letter-spacing:0.5rem; font-size:1.5rem; text-align:center;">
                    </div>

                    <p style="text-align:center; color:#8f9bb3; font-size:0.75rem; margin-top:0.25rem; margin-bottom:1.25rem;">
                      {{ 'TWO_FA.CODE_HINT' | translate }}
                    </p>

                    <button nbButton fullWidth status="primary" size="large" class="crsr"
                      [disabled]="totpCode.length !== 6" (click)="onLogin()">
                      {{ 'TWO_FA.VERIFY' | translate }}
                    </button>

                    <button nbButton fullWidth status="basic" size="medium" class="crsr"
                      style="margin-top:0.75rem;" (click)="backToLogin()">
                      {{ 'TWO_FA.BACK' | translate }}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> {{ 'LOGIN.LOADING' | translate }} </p>
</ngx-spinner>
